import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { ProtectedWrapper } from '@/components/ProtectedWrapper/ProtectedWrapper';
// Modules
import { config } from '@/lib/config';
import { log } from '@/lib/log';
import { trackUserAction } from '@/lib/tracking';
import { saveUTMParamsInSessionStorage } from '@/lib/util';
// Components
import AddressPage from '@/pages/Address';
import ApprovePage from '@/pages/Approve';
import ConfirmationPage from '@/pages/Confirmation';
import ErrorPage from '@/pages/Error';
import OutOfOrderPage from '@/pages/OutOfOrder/OutOfOrder';
import PaymentPage from '@/pages/Payment';
import ProductPage from '@/pages/Product';
import RedirectPage from '@/pages/Redirect';

/**
 * Router component that handles all routes
 *
 * @returns {React.ReactElement}
 */
const Routing = () => {
	const location = useLocation();
	const isOutOfOrder = import.meta.env.VITE_APP_OUT_OF_ORDER === 'true' && localStorage.getItem('maintenance') !== 'true';

	useEffect(() => {
		saveUTMParamsInSessionStorage(new URLSearchParams(location.search));
	}, [location]);

	useEffect(() => {
		log(`Sending page impression for ${location.pathname}`);

		void trackUserAction().catch((error) => {
			log('Failed to track page impression:', error);
		});
	}, [location]);

	const OutOfOrder = (
		<Route
			element={<OutOfOrderPage />}
			path="*"
		/>
	);

	return (
		<Routes>
			{isOutOfOrder ? (
				OutOfOrder
			) : (
				<>
					<Route
						element={<ProductPage />}
						path={`${config.routes.product}/:productRef`}
					/>
					<Route
						element={<ProtectedWrapper component={<AddressPage />} />}
						path={config.routes.address}
					/>
					<Route
						element={<ProtectedWrapper component={<PaymentPage />} />}
						path={config.routes.payment}
					/>
					<Route
						element={<ProtectedWrapper component={<ConfirmationPage />} />}
						path={config.routes.confirmation}
					/>
					<Route
						element={<ProtectedWrapper component={<ApprovePage />} />}
						path={config.routes.approve}
					/>
					<Route
						element={<RedirectPage />}
						path="/"
					/>
					<Route
						element={<ErrorPage />}
						path={config.routes.error}
					/>
					<Route
						element={<ErrorPage />}
						path="*"
					/>
				</>
			)}
		</Routes>
	);
};

export default Routing;
